module.exports = __webpack_public_path__ + "themes/soloppgang/fonts/TT-Ricordi-Marmo-Light.ttf";